const CardSubscriptionSkeleton = () => {
  return (
    <div className="relative h-full border rounded-xl animate-pulse w-full">
      <div className="bg-white rounded-xl p-6 pb-8 pt-4 flex flex-col items-center text-center relative">
        {/* Title & Icon */}
        <div className="flex items-center justify-between w-full mb-4">
          <div className="h-6 w-1/2 bg-gray-200 rounded" />
          <div className="w-[50px] h-[50px] bg-gray-200 rounded-full" />
        </div>

        {/* Price & Original Price */}
        <div className="flex flex-col items-start w-full mb-4">
          <div className="h-8 w-1/3 bg-gray-200 rounded" />
          <div className="h-4 w-1/4 bg-gray-100 rounded mt-2" />
        </div>

        {/* Button(s) */}
        <div className="w-full mb-4 space-y-3">
          <div className="h-10 bg-gray-300 rounded w-full" />
          <div className="h-10 bg-gray-100 rounded w-full" />
        </div>

        {/* Info box */}
        <div className="bg-gray-100 gap-3 p-3 rounded-xl border border-gray-200 flex items-center w-full mt-2">
          <div className="w-4 h-4 bg-gray-300 rounded-full" />
          <div className="h-4 w-3/4 bg-gray-200 rounded" />
        </div>

        {/* Features list */}
        <div className="mt-6 w-full text-left space-y-5">
          <div className="h-4 w-2/3 bg-gray-200 rounded" />
          {[...Array(3)].map((_, i) => (
            <div key={i} className="h-4 w-full bg-gray-100 rounded ml-4" />
          ))}
        </div>
      </div>
    </div>
  );
};

export default CardSubscriptionSkeleton;
